import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { getStringDate } from 'src/app/common/util';
import { ModalDialogComponent } from 'src/app/components/modals/modal-dialog/modal-dialog.component';
import { ExpenseDocDetailResponse, ExpenseResponse } from 'src/app/models/expense.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { ExpenseService } from 'src/app/services/expense.service';

@Component({
  selector: 'app-detail-docs',
  templateUrl: './detail-docs.component.html',
  styleUrls: ['./detail-docs.component.scss']
})
export class DetailDocsComponent implements OnInit {
  @Output() close = new EventEmitter<boolean>();
  @Input() docId: number;
  @Input() expenseDoc: ExpenseResponse;
  @Output() closed = new EventEmitter<boolean>();
  @Input() showModal: boolean = false;
  details: ExpenseDocDetailResponse[] = [];
  totalPurchase = 0;

  constructor(private expenseService: ExpenseService,
    private toastService: ToastrService) { }

  ngOnInit(): void {
    this.getDetails();
  }

  getDetails() {
    if (!this.expenseDoc) {
      return;
    }
    
    this.expenseService.getDetailDocument(this.docId).subscribe({
      next: (response: ResponseObject) => {
        this.details = response.data;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al obtener el detalle del gasto" + error.error.message);
      }
    });
  }

  closeModal(modal: ModalDialogComponent) {
    modal.onClose();
    this.closed.emit(true);
  }

  closeModalEmit() {
    this.closed.emit(true);
  }

  get total() {
    return (this.expenseDoc.total);
  }

  subtotal(quantity: number, price: number) {
    return (quantity * price);
  }

  convertToString(date: number) {
    if (!date) {
      return '';
    }
    var tempDate = new Date(date);
    return getStringDate(tempDate);
  }

}
